
export default {
  // get请求，参数为 id
  getUsers: {
    url: '/static/mock/login-success.json'
  },
  // post请求，参数为 userName, sex, age, phone, email
  addUser: {
    url: '/user/addUser'
  },
  /**
   *登录前获取验证码
   * @param params: {number: 邮箱或手机号}
   */
  getVerificationCode: {
    url: '/user/getVerificationCode'
  },

  /**
   * type: POST
   *用户注册
   * @param params: {number: 邮箱或手机号, code: 手机或邮箱收到的验证码, roleNum: 角色, userName: 用户名, password: 密码}
   */
  registerUser: {
    url: '/user/addByNumber'
  },

  /**
   * type: POST
   *用户注册或登录，返回会话id，前台用于查询用户信息并且cookie存储，用于15天内免登录
   * @param params: 手机或邮箱登录： {number: 邮箱或手机号, code: 手机或邮箱收到的验证码} 用户名密码登录: {userName: 用户名, password: 密码}
   */
  loginUser: {
    url: '/user/loginUser'
  },

  /**
   * type: PUT
   *根据用户id修改用户信息
   * @param params: nickName,realName,fixedPhone,sex,birth
   */
  updateUser: {
    url: '/user/updateUser'
  },

  /**
   * type: PUT
   *用户根据验证码重置密码
   * @param params: 手机或邮箱登录： {number: 邮箱或手机号, code: 手机或邮箱收到的验证码, newPassword: 新密码}
   */
  updatePassword: {
    url: '/user/updatePassword'
  },

  /**
   *登录前获取验证码
   * @param params: {userCode: 登录时或者cookie中缓存的会话id}
   */
  getCurrentUserInfoByCode: {
    url: '/user/getUserInfo'
  },

  /**
   *退出当前登录的用户
   * @param params: {userCode: 登录时或者cookie中缓存的会话id}
   */
  exitCurrentUser: {
    url: '/user/exitUser'
  },

  /**
   * type: GET
   *根据category类型查找
   * @param params: {category: 类型字段}
   */
  getAllDictByCategory: {
    url: '/dictionary/getAllDictByCategory'
  },

  /**
   * type: POST
   *新增保存职位信息
   * @param params: {
   * "positionName":"JAVA开发测试",
   * "salary":"SALARY0002",
   * "academicDegree":"EDUCATION0002",
   * "experience":"EXPERIENCE0002",
   * "companyCode":"SH120155452",
   * "sexReq":"02",
   * "labels":"程序员,小蜜蜂,大神"}
   */
  savePosition: {
    url: '/position/savePosition'
  },

  /**
   * type: POST
   *获取所有的职位信息（用户登录时）
   */
  getAllPosition: {
    url: '/position/getAllPositions'
  },

  /**
   * type: POST
   *获取所有的职位信息(用户未登录时)
   */
  getNewAllPositions: {
    url: '/position/getNewAllPositions'
  },

  /**
   * type: POST
   *关联职位，收藏和投递简历
   */
  createOrUpdateRelation: {
    url: '/relation/createOrUpdateRelation'
  },

  /**
   * type: GET
   *获取当前招聘者发布过的职位信息
   */
  getByCompanyCode: {
    url: '/position/getByCompanyCode'
  },

  /**
   * type: PUT
   *更新职位信息
   */
  updatePosition: {
    url: '/position/updatePosition'
  },

  /**
   * type: DELETE
   *删除职位信息
   * @param params: {id: 职位id}
   */
  deletePosition: {
    url: '/position/deletePosition'
  },

  /**
   * type: GET
   *获取当前用户的简历信息
   */
  getCurrentUsrResume: {
    url: '/resume/getByCurrUser'
  },

  /**
   * type: POST
   *保存用户头像信息
   */
  saveUserIcon: {
    url: '/user/updateOrSaveImage'
  },

  /**
   * type: GET
   *发送个人简历
   */
  sendMyResume: {
    url: '/user/sendResume'
  },

  /**
   * type: GET
   *简历下载
   */
  getUsrResume: {
    url: '/resume/downloadResume'
  },

  /**
   * type: POST
   *教育经历新增
   */
  educationExperienceSave: {
    url: '/education/experiences/saveEducationExperince'
  },

  /**
   * type: PUT
   *教育经历修改
   */
  educationExperienceEdit: {
    url: '/education/experiences/updateEducationExperince'
  },

  /**
   * type: DELETE
   *教育经历删除
   */
  educationExperienceDelete: {
    url: '/education/experiences/deleteEducationExperinceById'
  },

  /**
   * type: POST
   *期望职位新增
   */
  desirePositionSave: {
    url: '/desired/position/saveDesiredPosition'
  },

  /**
   * type: PUT
   *期望职位修改
   */
  desirePositionEdit: {
    url: '/desired/position/updateDesiredPosition'
  },

  /**
   * type: DELETE
   *期望职位删除
   */
  desirePositionDelete: {
    url: '/desired/position/deleteJobExperienceById'
  },

  /**
   * type: POST
   *保存职位信息浏览记录，用于热门搜索
   */
  savePositionViewRecord: {
    url: '/browse/record/saveBrowseRecord'
  },

  /**
   * type: GET
   *根据公司名称模糊搜索公司信息
   */
  queryCompanyByName: {
    url: '/company/getCompanyByCompanyName'
  },
  /**
   * type: POST
   *个人简历新增保存个人工作经历
   */
  saveNewWorkExperience: {
    url: '/job/experience/saveJobExperience'
  },
  /**
   * type: PUT
   *个人简历编辑保存个人工作经历
   */
  editWorkExperience: {
    url: '/job/experience/updateJobExperience'
  },
  /**
   * type: DELETE
   *个人简历删除个人工作经历
   */
  deleteWorkExperience: {
    url: '/job/experience/deleteJobExperienceById'
  },
  /**
   * type: PUT
   *个人简历基本信息更新接口
   */
  editMyResumeBaseInfo: {
    url: '/resume/updateResume'
  },
  /**
   * type: GET
   *首页获取最近浏览的职位
   */
  getRecentlyViewPositions: {
    url: '/position/getRecentlyPositions'
  },
  /**
   * type: GET
   *首页获取热门职位
   */
  getPopularPositions: {
    url: '/position/getPopularPositions'
  },
  /**
   * type: GET
   *首页获取公告栏信息
   */
  getBulletinBoardPosition: {
    url: '/position/getBulletinBoardPosition'
  },

  /**
   * type: GET
   *获取收到的简历数量统计
   */
  getResumeBasicNum: {
    url: '/resume/getCheckedResumes'
  },

  /**
   * type: GET
   *获取收到的简历
   */
  getApplyResume: {
    url: '/resume/getApplyResume'
  },

  /**
   * type: GET
   *根据id获取职位信息
   */
  getByPositionId: {
    url: '/position/getByPositionId'
  },
  /**
   * type: GET
   *发送简历到邮箱
   */
  sendEmail: {
    url: '/resume/sendResumeEmail'
  },

  /**
   * type: GET
   *获取职位类型树，
   * param: dictNum=PROFESSION 是根节点
   */
  getPositionTypeTree: {
    url: '/dictionary/getTreeByCategory'
  },
  /**
   * type: GET
   *通过高德地图获取地点坐标
   * @param params: keywords city=全国 output=JSON offset=20 page=1 key=14fdfb687668c6e14e609a84ee518aa6 extensions=all
   */
  getMapInfoByKeyword: {
    url: 'https://restapi.amap.com/v3/place/text',
    params: {
      keywords: '',
      city: '全国',
      output: 'JSON',
      offset: 10,
      page: 1,
      key: '14fdfb687668c6e14e609a84ee518aa6',
      extensions: 'all'
    }
  },

  /**
   * type: POST
   *支付接口
   */
  createQRcode: {
    url: '/pay/create/qRcode',
    params: {
      totalAmount: 0,
      outTradeNo: '',
      subject: '上海仁格社保代缴业务'
    }
  },

  /**
   * type: GET
   *根据userCode获取简历信息
   */
  getResumeByUserCode: {
    url: '/resume/getResumeByUserCode'
  },

  /**
   * type: POST
   *上传身份证照片 file
   */
  uploadIDCard: {
    url: '/document/upload/idCard?category=ID_CARD'
  },

  /**
   * type: GET
   *验证手机号是否正确
   */
  verifiCateIphone: {
    url: '/user/verificateIphone'
  },

  /**
   * type: GET
   *查询城市接口（社保）
   */
  getAllSocialStandard: {
    url: '/social/standard/getAllSocialStandard'
  },

  /**
   * type: GET
   *查询社保套餐
   */
  getAllActivityPackage: {
    url: '/activity/package/getAllActivityPackage'
  },

  /**
   * type: POST
   *保存社保套餐
   */
  saveActivityPackage: {
    url: '/activity/package/saveActivityPackage'
  },

  /**
   * type: POST
   *计算社保套餐价格
   */
  calculatePrice: {
    url: '/social/security/calculatePrice'
  },

  /**
   * type: POST
   *保存社保订单到未支付
   */
  saveSocialSecuritInfo: {
    url: '/social/security/saveSocialSecuritInfo'
  },

  /**
   * type: POST
   *确认并支付
   */
  saveDirectSecuritInfo: {
    url: '/social/security/saveDirectSecuritInfo'
  },

  /**
   * type: GET
   *查询订单信息
   */
  getAllOrderInfo: {
    url: '/orderInfo/getAllOrderInfo'
  },

  getAllSecuritInfo: {
    url: '/social/security/getAllSecuritInfo'
  },

  /**
   * type: POST
   *勾选多个未支付的社保单号，生成订单，并拉起支付宝二维码
   */
  saveOrderInfo: {
    url: '/orderInfo/saveOrderInfo'
  },

  /**
   * type: DELETE
   *勾选多个未支付的社保单号，生成订单，并拉起支付宝二维码
   */
  deleteSecuritInfoById: {
    url: '/social/security/deleteSecuritInfoById'
  },

  /**
   * type: POST
   *新增新闻
   */
  saveNews: {
    url: '/news/saveNews'
  },

  /**
   * type: PUT
   *修改新闻
   */
  updateNews: {
    url: '/news/updateNews'
  },

  /**
   * type: DELETE
   *单条删除新闻
   */
  deleteNewsById: {
    url: '/news/deleteNewsById'
  },
  /**
   * type: GET
   *查询新闻
   */
  getNews: {
    url: '/news/getAllNews'
  },

  /**
   * type: POST
   *检查敏感字符
   */
  checkSensitiveWords: {
    url: '/sensitive/checkSensitiveWord'
  },

  /**
   * type: POST
   *新闻刷新间隔时间查询和设置  urlParam： timeInterval 有参数是设置，没参数是查询
   */
  newsRefreshInterval: {
    url: '/test/user/getOrSetTimeInterval'
  },

  /**
   * type: DELETE
   *删除订单
   */
  deleteOrder: {
    url: '/orderInfo/deleteOrderInfo'
  },

  /**
   * type: GET
   *根据id查询订单信息
   */
  getOrderInfoById: {
    url: '/orderInfo/getOrderInfoById'
  },

  /**
   * type: POST
   *admin查询所有社保
   */
  getListSocialSecurity: {
    url: '/social/security/getListSocialSecurity'
  },

  /**
   * type: POST
   *damin导出社保
   */
  exportSocialSecurityOrder: {
    url: '/social/security/exportSecurityInfo'
  },
  /**
   * type: POST
   *damin导出社保
   */
  getResumeTemplate: {
    url: '/excel/download/template',
    param: {
      name: '个人信息模板',
      suffix: 'xlsx',
      pelativePath: 'template'
    }
  },
  /**
   * type: GET
   * 查询人才储备
   */
  queryPersonnel: {
    url: '/user/queryPersonnel'
  },
  /**
   * type: GET
   * 导出人才储备 /user/exportQueryPersonnel
   */
  exportQueryPersonnel: {
    url: '/user/exportQueryPersonnel'
  },
  /**
   * type: DELETE
   * 导出人才储备 /user/batchDeleteByCode
   */
  batchDeleteByCode: {
    url: '/user/batchDeleteByCode'
  },
  /**
   * type: PUT
   * 人才储备修改用户信息 /user/updatePersonnelByUserCode
   */
  updatePersonnelByUserCode: {
    url: '/user/updatePersonnelByUserCode'
  },
  /**
   * type: POST
   * 人才储备添加用户信息 /user/addPersonnelByUserCode
   */
  addPersonnelByUserCode: {
    url: '/user/addPersonnelByUserCode'
  },
  /**
   * type: GET
   * 查询广告 /advertisement/getAdvertisements
   */
  getAdvertisements: {
    url: '/advertisement/getAdvertisements'
  },
  /**
   * type: POST
   * 添加广告 /advertisement/addAdvertisement
   */
  addAdvertisement: {
    url: '/advertisement/addAdvertisement'
  },
  /**
   * type: PUT
   * 修改广告 /advertisement/updateAdvertisement
   */
  updateAdvertisement: {
    url: '/advertisement/updateAdvertisement'
  },
  /**
   * type: DELETE
   * 批量删除广告 /advertisement/batchDeleteAdvertisement
   */
  batchDeleteAdvertisement: {
    url: '/advertisement/batchDeleteAdvertisement'
  },
  /**
   * type: GET
   * 查询公告 /notice/getNotices
   */
  getNotices: {
    url: '/notice/getNotices'
  },
  /**
   * type: POST
   * 添加公告 /notice/addNotice
   */
  addNotice: {
    url: '/notice/addNotice'
  },
  /**
   * type: PUT
   * 修改公告 /notice/updateNotice
   */
  updateNotice: {
    url: '/notice/updateNotice'
  },
  /**
   * type: PUT
   * 置顶公告信息 /notice/topNotice
   */
  topNotice: {
    url: '/notice/topNotice'
  },
  /**
   * type: DELETE
   * 批量删除公告 /notice/deleteNotice
   */
  deleteNotice: {
    url: '/notice/deleteNotice'
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js